import { FC } from "react"
import * as React from "react"

import { faqs } from "config/faq"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import * as styles from "./styles.module.scss"
import Back from "../Faq/Back"
import Document from "../Document"
import Footer from "../Footer"
import Link from "gatsby-link"
import LinkUnderline from "../LinkUnderline"
import Navbar from "../Navbar"
import PageWrapper, { PaddingTop } from "../PageWrapper"
import QuestionVideos from "../Faq/QuestionVideos"
import SideNav from "../SideNav"

export interface QuestionProps {
  categoryId?: string
  pageContext: any
  bare?: boolean
}

const Question: FC<QuestionProps> = ({
  pageContext,
  categoryId: categoryIdProp,
  bare = false,
}) => {
  const {
    question,
    id,
    answer,
    videos,
    categoryId: categoryIdContext,
  } = pageContext

  const categoryId = categoryIdContext || categoryIdProp

  const relatedQuestions = faqs
    .filter((i) => i.id === categoryId)[0]
    .faq.filter((f) => f.id !== id)

  return (
    <Document
      title={question}
      description="Frequently asked questions. Learn about our rates, process, loan types and products, and servicing."
      pageId={`Faq-${id}`}
      pageClass="bet-StaticPage bet-Faq"
    >
      {!bare && (
        <>
          <Navbar getStartedType={GetStartedType.ALWAYS} />
          <SideNav />
        </>
      )}
      <PageWrapper paddingTop={PaddingTop.Navbar}>
        <main>
          <div className={styles.question}>
            <div className={styles.pagePadding}>
              <div className={styles.back}>
                <Back backLink="/faq" bare={bare} />
              </div>
              <article className={styles.body}>
                <header className={styles.header}>
                  <dt>
                    <h1 className={styles.heading}>{question}</h1>
                  </dt>
                </header>
                <div className={styles.answer}>
                  <dd dangerouslySetInnerHTML={{ __html: answer }} />
                </div>
                {videos && (
                  <div className={styles.videos}>
                    <QuestionVideos videos={videos} />
                  </div>
                )}
              </article>
              {relatedQuestions && (
                <aside className={styles.related}>
                  <h4 className={styles.relatedHeading}>Related questions</h4>
                  <ul className={styles.relatedList}>
                    {relatedQuestions.map((item) => {
                      return (
                        <li className={styles.relatedItem} key={item.id}>
                          <Link
                            className={styles.relatedQuestion}
                            to={`/faq/${categoryId}/${item.id}${
                              bare ? "?bare=true" : ""
                            }`}
                          >
                            <LinkUnderline>{item.question}</LinkUnderline>
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </aside>
              )}
            </div>
          </div>
        </main>
        {!bare && <Footer />}
      </PageWrapper>
    </Document>
  )
}

export default Question
